import { createFileRoute } from '@tanstack/react-router';

import { BlockEditPage, blockQueryOptions } from '@/features/content';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/blocks/$blockId')({
  staticData: { tours: ['content.block-editor'] },
  loader: async ({ context, params }) => {
    const row = await context.queryClient.query({
      ...blockQueryOptions(params.storeId, params.blockId),
      staleTime: 'static',
    });
    return { crumb: row.name };
  },
  component: BlockEditPage,
});
